import { heroStats } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-100">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-primary-100/60 blur-3xl"></div>
        <div className="absolute bottom-0 left-0 h-72 w-72 rounded-full bg-accent-100/50 blur-3xl"></div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6 pt-28 md:pt-36 pb-16 md:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-12 lg:gap-16">
          <div className="w-full">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs md:text-sm font-medium text-primary-700">
              <i className="ri-bookmark-3-line"></i>
              入口 · 地址 · 下载 一站整理
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-black leading-tight text-foreground-950">
              中文在线字幕免费高清
            </h1>

            <p className="mt-5 max-w-xl text-base md:text-lg leading-relaxed text-foreground-700">
              聚合<strong className="font-semibold text-foreground-900">官方平台入口</strong>、
              <strong className="font-semibold text-foreground-900">最新地址</strong>与
              <strong className="font-semibold text-foreground-900">app 下载方式</strong>，
              帮你解决找不到网址、页面打不开的困扰。本页不提供播放内容，只把「去哪里找、怎么辨别、如何下载」讲清楚。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-3">
              <a
                href="#entry"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 dark:text-foreground-950 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                查看官方平台入口
              </a>
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-900 transition-colors hover:bg-secondary-100 cursor-pointer"
              >
                <i className="ri-download-2-line"></i>
                获取 App 下载方式
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-4 md:gap-6 border-t border-background-300/70 pt-6">
              {heroStats.map((s) => (
                <div key={s.label}>
                  <dt className="font-heading text-xl md:text-2xl font-bold text-primary-700">
                    {s.value}
                  </dt>
                  <dd className="mt-1 text-xs md:text-sm text-foreground-600">{s.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="w-full">
            <div className="relative mx-auto w-full max-w-md lg:max-w-none">
              <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20abstract%20illustration%20of%20a%20modern%20video%20streaming%20interface%20in%20warm%20amber%20cream%20and%20soft%20sage%20tones%2C%20floating%20subtitle%20caption%20bars%20over%20an%20artistic%20gradient%20backdrop%2C%20paper%20texture%2C%20minimal%20editorial%20style%2C%20calm%20refined%20composition%2C%20plenty%20of%20negative%20space&width=1000&height=1180&seq=subtitle-hero-01&orientation=portrait"
                  alt="中文在线字幕平台的字幕与播放界面示意插画"
                  className="h-72 md:h-[420px] lg:h-[500px] w-full object-cover object-top"
                />
              </div>

              <div className="absolute -bottom-5 left-4 right-4 md:left-6 md:right-6 rounded-lg border border-background-200 bg-background-50 p-3 md:p-4">
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className="ri-information-line"></i>
                  </span>
                  <p className="text-xs md:text-sm leading-relaxed text-foreground-700">
                    本页为信息整理页面，实际服务与内容以官方平台为准。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}